<template>
  <!-- Trip details section -->
  <v-card flat class="mb-5" color="transparent" style="position: relative">
    <v-card-title class="d-flex justify-space-between align-start" style="word-break: normal">
      <div style="max-width: 80%">
        Your trip to
        {{ trip.itinerary.destination ? trip.itinerary.destination.name : '' }}
      </div>
    </v-card-title>
    <v-card-text>
      <ul style="list-style: none" class="pl-0 mt-4 mt-sm-0">
        <li>{{ niceDuration(trip.itinerary.totalTravelTime) }} total driving time</li>
        <li>{{ Math.round(trip.itinerary.totalDrivingDistance / 1000) }}Km driven</li>
        <li>{{ trip.numberOfScheduledStops }} planned stops along the way</li>
        <li>{{ trip.chargingStopCDBIDs.length }} additional {{ displayAsHydrogen ? 'fuel' :  'charging' }} stops </li>
      </ul>
    </v-card-text>
    <!-- Floating Action buttons -->
    <div v-if="!hideBtns" class="d-flex" style="position: absolute; top: 8px; right: 0">
      <v-card
        @click="emit('exit')"
        flat
        class="d-flex flex-column justify-center align-center py-1 px-2"
        color="transparent"
      >
        <div
          class="rounded-circle d-flex justify-center align-center"
          style="border: 1px solid lightgray; height: 30px; width: 30px"
        >
          <v-icon color="pwt_light_grey" size="x-small"> mdi-close </v-icon>
        </div>
        <p class="pa-0 text-caption">Exit</p>
      </v-card>
      <v-card
        @click="emit('save')"
        flat
        class="d-flex flex-column justify-center align-center py-1 px-2"
        color="transparent"
      >
        <div
          class="rounded-circle d-flex justify-center align-center"
          style="border: 1px solid rgb(var(--v-theme-pwt_azure)); height: 30px; width: 30px"
        >
          <v-icon color="pwt_azure" size="x-small"> mdi-bookmark-outline </v-icon>
        </div>
        <p class="pa-0 text-caption">Save</p>
      </v-card>
    </div>
  </v-card>
</template>

<script setup lang="ts">
import Trip from '@/classes/trip_classes/trip';
import { isHydrogen } from '@/utils/hydrogenUtils';
import { getNiceDuration } from '@/utils/timeUtils';
import { computed } from 'vue';

const { trip, hideBtns = false } = defineProps<{ trip: Trip; hideBtns?: boolean }>()

const niceDuration = (seconds: number): string => {
  return getNiceDuration(seconds)
}

const emit = defineEmits(['exit', 'save'])

const displayAsHydrogen = computed(() => trip.vehicle && isHydrogen(trip.vehicle))
</script>
